import { recipes } from '../../data/content';
import './RecipesPage.css';

function RecipesPage() {
  return (
    <>
      <section className="section-block page-card">
        <h2>Horeca / Wholesale</h2>
        <div className="recipe-grid">
          <article className="recipe-card">
            <h3>Hotels & Restaurants Supply</h3>
            <p>Bulk pack formats with predictable quality and delivery wdwdschedules.h ho </p>
          </article>
          <article className="recipe-card">
            <h3>Catering Partner Support</h3>
            <p>Large event volume planning with consistent product availability.</p>
          </article>
          <article className="recipe-card">
            <h3>QSR Ingredient Program</h3>
            <p>Ready-to-use corn packs for fast service menu standardwdwddwization.</p>
          </article>
        </div>
      </section>

      <section className="section-block page-card">
        <h2>Quick Recipe Ideas</h2>
        <div className="recipe-grid">
          {recipes.map((recipe) => (
            <article className="recipe-card" key={recipe.title}>
              <h3>{recipe.title}</h3>
              <p>{recipe.description}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}

export default RecipesPage;
